import dayjs from 'dayjs';

import {
  Box,
  Checkbox,
  CircularProgress,
  IconButton,
  Step,
  StepLabel,
  Stepper,
  SwipeableDrawer,
  TextField,
  Tooltip,
} from '@mui/material';
import { CloseRounded, SearchRounded } from '@mui/icons-material';

import React, { useState, useEffect, useCallback } from 'react';
import { toast } from 'react-toastify';

import {
  Button,
  Container,
  Header,
  HeaderCreate,
  Page,
  PageMeetings,
  TabButton,
  Text,
  TitleBox,
} from './styles';

import {
  Board,
  createMeetingRequest,
  getActiveBoardsByCompanyId,
  getBoardByIdRequest,
  getCanceledMeetingsByUse,
  getPastMeetingsRequest,
  Guest,
  ListaReuniaoComMesAno,
  Meeting,
} from '../../services';

import { ReunioesFuturas } from './Futuras';
import { ReunioesPassadas } from './Passadas';
import { CriarReuniao } from './CriarReuniao';
import { StepBoard } from './StepBoard';
import { StepMembros } from './StepMembros';
import { SuccessMessage } from './SuccessMessage';

import { convertStringToDateToSave } from '../../utils/dateHelpers';

import { LoadingBackdrop } from '../../components/LoadingBackdrop';

import useAuthStore from '../../store/auth';
import useCompanyStore from '../../store/companies';

import { useFutureMeetings } from '../../hooks/useMeetings';

dayjs().format();

const stepsLabel = ['Board', 'Membros', 'Informações', 'Reunião criada'];

export interface GuestToSelect extends Guest {
  selected: boolean;
  boardProfile: 'BMS1' | 'BMS2';
}

export interface ManualRecurrence {
  id: number;
  initial_date: string;
  initial_hour: string;
  duration: number;
}

export interface GuestToSelectNote extends Guest {
  selectedNote: boolean;
}

export function Reuniao() {
  const user = useAuthStore(state => state.user);
  const selectedCompany = useCompanyStore(state => state.selectedCompany);

  const [listagemBoards, setListagemBoards] = useState<Board[]>([]);
  const [tabSelected, setTabSelected] = useState('futuras');
  const [listagemReunioesFuturas, setListagemReunioesFuturas] = useState<
    ListaReuniaoComMesAno[] | undefined
  >([]);
  const [listagemReunioesPassadas, setListagemReunioesPassadas] = useState<
    ListaReuniaoComMesAno[] | undefined
  >([]);
  const [listagemReunioesCanceladas, setListagemReunioesCanceladas] = useState<
    ListaReuniaoComMesAno[] | undefined
  >([]);
  const [loading, setLoading] = useState(false);
  const [openDrawerCreateMeeting, setOpenDrawerCreateMeeting] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [skipped, setSkipped] = useState(new Set<number>());
  const [listaUsuarios, setListaUsuarios] = useState<
    GuestToSelect[] | undefined
  >([]);
  const [listaUsuariosBoard, setListaUsuariosBoard] = useState<
    any[] | undefined
  >([]);
  const [listaConvidados, setListaConvidados] = useState<Guest[] | undefined>(
    [],
  );
  const [meetingIdCreatedAt, setMeetingIdCreatedAt] = useState('');
  const [selected, setSelected] = useState<readonly string[]>([]);
  const [selectedBoardId, setSelectedBoardId] = useState('');
  const [searchForMeetings, setSearchForMeetings] = useState('');
  const [listagemRecorrenciasManuais, setListagemRecorrenciasManuais] =
    useState<ManualRecurrence[]>([]);
  const [checked, setChecked] = useState(false);
  const [hasMeetingInvite, setHasMeetingInvite] = useState(true);
  const [loadingBackDrop, setLoadingBackDrop] = useState(false);
  const [zoomActived, setZoomActived] = useState(false);
  const [teamsActived, setTeamsActived] = useState(false);
  const [jitsiActived, setJitsiActived] = useState(false);
  const [selectedAll, setSelectedAll] = useState<boolean | null>(null);
  const [loadingZoom, setLoadingZoom] = useState(false);
  const [authorizationCode, setAuthorizationCode] = useState<string | null>(
    null,
  );

  const { isLoading, listOfFutureMeetings, status, error } =
    useFutureMeetings(searchForMeetings);

  useEffect(() => {
    if (status === 'error' && error) {
      console.error('Error Query', error);
      toast.error('Erro ao buscar reuniões');
    }
  }, [status, error]);

  const handleChangeCheckbox = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
    setSearchForMeetings('');
    setTabSelected('futuras');
  };

  const loadBoards = useCallback(async () => {
    try {
      const response = await getActiveBoardsByCompanyId(
        selectedCompany?.id as string,
        '',
        user?.id as string,
      );

      setListagemBoards(response?.data);
    } catch (err) {
      console.log(err);
    }
  }, [selectedCompany?.id, user?.id]);

  useEffect(() => {
    if (selectedCompany) {
      loadBoards();
    }
  }, [user, selectedCompany]);

  const hasBoardsAdmin = useCallback(() => {
    const boardsFilteredWithAdmin = listagemBoards?.map(
      b => b.members?.find(u => u.id === user?.id)?.profile === 'BMS1',
    );
    const hasAdmin = boardsFilteredWithAdmin?.find(b => b === true);

    if (hasAdmin) {
      return false;
    }
    return true;
  }, [listagemBoards, user?.id]);

  const loadCanceledMeetings = useCallback(async () => {
    try {
      setLoading(true);

      const response = await getCanceledMeetingsByUse(
        user?.id as string,
        selectedCompany?.id as string,
        searchForMeetings as string,
      );

      if (response?.status === 200) {
        setListagemReunioesCanceladas(response?.data);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }, [searchForMeetings, selectedCompany?.id, user?.id]);

  async function loadPastMeetings() {
    try {
      setLoading(true);
      const responsePassadas = await getPastMeetingsRequest(
        user?.id as string,
        selectedCompany?.id as string,
        searchForMeetings,
      );

      if (responsePassadas?.length > 0) {
        setListagemReunioesPassadas(responsePassadas || []);
      } else {
        setListagemReunioesPassadas([]);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    setLoading(true);
    if (selectedCompany) {
      const delayDebounceFn = setTimeout(() => {
        loadPastMeetings();
        if (checked) {
          loadCanceledMeetings();
        }
      }, 1000);
      return () => clearTimeout(delayDebounceFn);
    }
  }, [searchForMeetings, checked]);

  async function loadUsers() {
    const response = await getBoardByIdRequest(selectedBoardId as string);

    const usersFromBoardSelected = response?.data?.members;

    if (usersFromBoardSelected.length > 0) {
      const guests = usersFromBoardSelected.map((u: Guest) => ({
        ...u,
        selected: false,
        boardProfile: u?.profile,
      }));
      const usersFiltered = guests?.filter(
        (userF: any) => userF.id !== user?.id,
      );
      setListaUsuarios(usersFiltered);
      setListaUsuariosBoard(usersFiltered);
    }
  }

  const isStepSkipped = useCallback(
    (step: number) => {
      return skipped.has(step);
    },
    [skipped],
  );

  const handleNext = useCallback(() => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep(prevActiveStep => prevActiveStep + 1);
    setSkipped(newSkipped);
  }, [activeStep, isStepSkipped, skipped]);

  const handleCheck = (type: string) => {
    setTabSelected(type);
  };
  const handleBack = () => {
    setActiveStep(prevActiveStep => prevActiveStep - 1);
  };

  const handleDrawerCriarReuniaoClose = () => {
    setSelectedBoardId('');
    setActiveStep(0);
    setSkipped(new Set<number>());
    setOpenDrawerCreateMeeting(false);
  };

  const handleUserToInvite = useCallback(
    (
      event: React.MouseEvent<unknown>,
      name: string,
      usr: GuestToSelect,
      idx: number,
      type: 'select' | 'profile',
    ) => {
      event.stopPropagation();
      const selectedIndex = selected.indexOf(name);
      let newSelected: readonly string[] = [];

      let listaUsuariosEditada = { ...usr };

      if (type === 'select') {
        if (selectedIndex === -1) {
          newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
          newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
          newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
          newSelected = newSelected.concat(
            selected.slice(0, selectedIndex),
            selected.slice(selectedIndex + 1),
          );
        }

        setSelected(newSelected);
        listaUsuariosEditada.selected = !usr?.selected;
      }

      // if (type === 'select') {
      //   listaUsuariosEditada.selected = !usr?.selected;
      // }

      if (type === 'profile') {
        listaUsuariosEditada.profile = usr?.profile === 'GS1' ? 'GS2' : 'GS1';
      }

      listaUsuarios?.splice(idx, 1, listaUsuariosEditada);

      setListaUsuarios([...listaUsuarios!]);
      const usuariosConvidados = listaUsuarios?.filter(u => u.selected);

      setListaConvidados([...usuariosConvidados!]);
    },
    [listaUsuarios, selected],
  );

  // const isSelected = (name: string) => selected.indexOf(name) !== -1;

  const handleMeeting = useCallback(
    async (formData: any) => {
      try {
        setLoadingBackDrop(true);
        const dataAtual = new Date();

        const guests = listaConvidados?.map(m => ({
          id: m.id,
          name: m.name,
          email: m.email,
          profile: m.profile,
          status: m.status,
          avatar_url: m.avatar_url,
        }));

        const owner = {
          id: user?.id as string,
          name: user?.name as string,
          email: user?.email as string,
          profile: 'GS1' as 'GS1' | 'GS2',
          status: user?.status as 'US1' | 'US2' | 'US3',
          avatar_url: user?.avatar_url,
        };

        guests?.push(owner);

        let recurrence_meetings: any[] = [];
        let first_meeting: any = {};
        if (listagemRecorrenciasManuais?.length > 0) {
          const formattedRecurrence = listagemRecorrenciasManuais?.map(m => ({
            title: formData.title,
            start_at: convertStringToDateToSave(
              `${m?.initial_date}T${m?.initial_hour}`,
            ),
            duration: m?.duration,
            local_address: formData.local_address || null,
            link_address: formData.link_address || null,
            has_invite: hasMeetingInvite,
            guests,
            company_id: selectedCompany?.id,
            user_id: user!.id,
            board_id: selectedBoardId,
            status: 'MS1',
            video_conference_id: null,
            ata_url: null,
            file_id: null,
          }));
          first_meeting = formattedRecurrence.shift();
          recurrence_meetings = formattedRecurrence;
        }

        const meeting = {
          title: formData.title,
          start_at: first_meeting?.start_at,
          duration: formData.duration,
          has_invite: hasMeetingInvite,
          local_address: formData.local_address || null,
          link_address: formData.link_address || null,
          guests,
          company_id: selectedCompany?.id,
          recurrence_meetings,
        };

        const redirectUrlZoom = authorizationCode
          ? `${process.env.REACT_APP_API_URL}/autenticacao-sucesso`
          : null;

        // if (dataAtual.getTime() > meeting.start_at.getTime()) {
        //   toast.warning('Não é permitido criar reuniões com datas passadas');
        // } else {
        const response = await createMeetingRequest(
          meeting as any,
          user!.id as string,
          selectedBoardId as string,
          selectedCompany?.id as string,
          teamsActived,
          jitsiActived,
          authorizationCode,
          redirectUrlZoom,
        );

        if (response?.status === 201) {
          const reuniaoCriada: Meeting = response?.data;
          const mesmaDataHora = listagemReunioesFuturas?.some(e =>
            e.meetings?.find(r => r.start_at === reuniaoCriada.start_at),
          );

          if (mesmaDataHora) {
            toast.warning(
              `Reunião criada com sucesso, porém identificamos outra com mesma data e hora`,
            );
            setMeetingIdCreatedAt(reuniaoCriada?.id as string);
            handleNext();
          } else {
            setMeetingIdCreatedAt(reuniaoCriada?.id as string);

            handleNext();
          }
        }
        // }
      } catch (err) {
        console.log({ err });
      } finally {
        setLoadingBackDrop(false);
      }
    },
    [
      listaConvidados,
      user,
      listagemRecorrenciasManuais,
      hasMeetingInvite,
      selectedCompany?.id,
      authorizationCode,
      selectedBoardId,
      teamsActived,
      jitsiActived,
      listagemReunioesFuturas,
      handleNext,
    ],
  );

  const handleSelectAllClick = () => {
    setSelectedAll(prev => !prev);
  };

  useEffect(() => {
    if (selectedBoardId) {
      loadUsers();
    }
  }, [selectedBoardId]);

  useEffect(() => {
    if (activeStep === 0) {
      setSelectedAll(null);
    }
    if (activeStep === 1) {
      setSelectedAll(true);
    }
  }, [activeStep]);

  useEffect(() => {
    if (selectedAll === null) {
      const users = listaUsuarios?.map(u => ({
        ...u,
        profile: 'GS2',
      }));
      const usersByBoards = listaUsuarios?.map(u => ({
        ...u,
      }));
      setListaUsuarios([...(users as any)!]);
      setListaConvidados([...(users as any)!]);
      setListaUsuariosBoard([...(usersByBoards as any)!]);
    } else if (selectedAll === false) {
      const usersUnselected = listaUsuarios?.map(u => ({
        ...u,
        profile: 'GS2',
        selected: false,
      }));
      const usersByBoards = listaUsuarios?.map(u => ({
        ...u,
        selected: false,
      }));
      setListaUsuarios([...(usersUnselected as any)!]);
      setListaUsuariosBoard([...(usersByBoards as any)!]);
      setListaConvidados([]);
    } else if (selectedAll === true) {
      const usersSelected = listaUsuarios?.map(u => ({
        ...u,
        profile: 'GS2',
        selected: true,
      }));
      const usersByBoards = listaUsuarios?.map(u => ({
        ...u,
        selected: true,
      }));
      setListaUsuarios([...(usersSelected as any)!]);
      setListaUsuariosBoard([...(usersByBoards as any)!]);
      setListaConvidados([...(usersSelected as any)!]);
    }
  }, [selectedAll]);

  const drawerCriarReuniao = () => (
    <Box width="960px" height="100%" display="flex" flexDirection="column">
      {loadingBackDrop && (
        <LoadingBackdrop
          component=""
          loading={loadingBackDrop}
          text="Criando reunião"
        />
      )}
      {loadingZoom && (
        <LoadingBackdrop
          loading={loadingZoom}
          text="Autenticando com sua conta Zoom"
          component=""
        />
      )}
      <HeaderCreate>
        <IconButton onClick={handleDrawerCriarReuniaoClose}>
          <CloseRounded />
        </IconButton>
        <TitleBox className="edit-dados">Criar Reunião</TitleBox>
      </HeaderCreate>
      <Page sx={{ padding: '20px', height: '100%' }}>
        <Stepper
          activeStep={activeStep}
          sx={{ mb: '20px', padding: '0px 55px' }}
        >
          {stepsLabel.map((label, index) => {
            const stepProps: { completed?: boolean } = {};
            const labelProps: {
              optional?: React.ReactNode;
            } = {};

            if (isStepSkipped(index)) {
              stepProps.completed = false;
            }
            return (
              <Step key={label} {...stepProps}>
                <StepLabel {...labelProps}>{label}</StepLabel>
              </Step>
            );
          })}
        </Stepper>
        {activeStep === 0 && (
          <StepBoard
            handleNext={handleNext}
            selectedBoardId={selectedBoardId}
            setSelectedBoardId={setSelectedBoardId}
          />
        )}
        {activeStep === 1 && (
          <Box height="100%">
            <StepMembros
              handleNext={handleNext}
              handleBack={handleBack}
              handleUserToInvite={handleUserToInvite}
              users={listaUsuarios}
              members={listaConvidados}
              handleEditMeeting={handleMeeting}
              loadingRequest={loading}
              setSelectedAll={setSelectedAll}
              selectedAll={selectedAll}
              handleSelectedAll={handleSelectAllClick}
            />
          </Box>
        )}
        {activeStep === 2 && (
          <CriarReuniao
            teamsActived={teamsActived}
            setTeamsActived={setTeamsActived}
            zoomActived={zoomActived}
            setZoomActived={setZoomActived}
            handleBack={handleBack}
            handleMeeting={handleMeeting}
            hasMeetingInvite={hasMeetingInvite}
            setHasMeetingInvite={setHasMeetingInvite}
            listagemRecorrenciasManuais={listagemRecorrenciasManuais}
            setListagemRecorrenciasManuais={setListagemRecorrenciasManuais}
            setLoadingZoom={setLoadingZoom}
            authorizationCode={authorizationCode}
            setAuthorizationCode={setAuthorizationCode}
            setJitsiActived={setJitsiActived}
            jitsiActived={jitsiActived}
          />
        )}
        {activeStep === 3 && (
          <SuccessMessage
            handleNext={handleNext}
            meetingIdCreatedAt={meetingIdCreatedAt}
          />
        )}
      </Page>
    </Box>
  );

  // const intObserver = useRef<IntersectionObserver | null>(null);
  // const lastFutureMeeting = useCallback(
  //   (futureMeeting: any) => {
  //     if (isLoading || isMainLoading) return;

  //     if (intObserver?.current) intObserver.current?.disconnect();

  //     intObserver.current = new IntersectionObserver(futMeetings => {
  //       if (futMeetings[0].isIntersecting && hasNextPage) {
  //         console.log('We are near the last meeting');
  //         fetchNextPage();
  //       }
  //     });

  //     if (futureMeeting) intObserver?.current?.observe(futureMeeting);
  //   },
  //   [isLoading, hasNextPage, isMainLoading, fetchNextPage],
  // );

  // const transformMeetingChunkByMonth = (meetingWithMonth: any[]) => {
  //   // console.log('meetingWithMonth', meetingWithMonth);

  //   let meetingsFormatted: any[] = [];

  //   if (meetingWithMonth && meetingWithMonth?.length > 0) {
  //     meetingWithMonth?.map((mm: any) => {
  //       const monthExists = meetingsFormatted.some(o => o.data === mm.data);

  //       if (monthExists) {
  //         const monthIndex = meetingsFormatted.findIndex(
  //           o => o.data === mm.data,
  //         );
  //         meetingsFormatted[monthIndex] = {
  //           data: meetingsFormatted[monthIndex].data,
  //           meetings: [
  //             ...meetingsFormatted[monthIndex].meetings,
  //             ...(mm.meetings as any),
  //           ],
  //         };
  //       } else {
  //         meetingsFormatted = [...meetingsFormatted, { ...(mm as any) }];
  //       }

  //       return meetingsFormatted;
  //     });
  //   }

  //   return meetingsFormatted;
  // };

  // const formatMeetingsListArrayInOnlyOne = (meetingsList: any[]) => {
  //   // console.log('meetingsList', meetingsList);

  //   let meetingsFormattedInOnlyOneList: any[] = [];

  //   if (meetingsList && meetingsList?.length > 0) {
  //     meetingsList
  //       ?.flatMap(f => f)
  //       .map((mm: any) => {
  //         const monthExists = meetingsFormattedInOnlyOneList.some(
  //           o => o.data === mm.data,
  //         );

  //         if (monthExists) {
  //           const monthIndex = meetingsFormattedInOnlyOneList.findIndex(
  //             o => o.data === mm.data,
  //           );
  //           meetingsFormattedInOnlyOneList[monthIndex] = {
  //             data: meetingsFormattedInOnlyOneList[monthIndex].data,
  //             meetings: [
  //               ...meetingsFormattedInOnlyOneList[monthIndex].meetings,
  //               ...(mm.meetings as any),
  //             ],
  //           };
  //         } else {
  //           meetingsFormattedInOnlyOneList = [
  //             ...meetingsFormattedInOnlyOneList,
  //             { ...(mm as any) },
  //           ];
  //         }

  //         return meetingsFormattedInOnlyOneList;
  //       });
  //   }

  //   return meetingsFormattedInOnlyOneList;
  // };

  // const futureMeetingsFormatted = listOfFutureMeetings?.pages.map(pg => {
  //   const futureMeetingsListFormatted = transformMeetingChunkByMonth(pg);

  //   return futureMeetingsListFormatted;
  // });

  // // console.log('futureMeetingsFormatted', futureMeetingsFormatted);
  // const futureMeetingsList = formatMeetingsListArrayInOnlyOne(
  //   futureMeetingsFormatted as any[],
  // );

  // console.log('futureMeetingsList', futureMeetingsList);

  // const futureMeetings = futureMeetingsList?.map(
  //   (meetings: any, index: number) => {
  //     if (futureMeetingsList && futureMeetingsList?.length === index + 1) {
  //       // console.log('ultimo');
  //       return (
  //         <>
  //           <ReunioesFuturas
  //             key={meetings?.data}
  //             ref={lastFutureMeeting}
  //             reunioes={meetings}
  //             reunioesCanceladas={listagemReunioesCanceladas}
  //             loading={isMainLoading}
  //             checked={checked}
  //           />
  //           {isLoading && (
  //             <Box
  //               paddingBottom="20px"
  //               marginTop="-20px"
  //               alignSelf="center"
  //               justifyContent="center"
  //               display="center"
  //               width="100%"
  //             >
  //               <Skeleton
  //                 sx={{ borderRadius: 2 }}
  //                 variant="rectangular"
  //                 width="100%"
  //                 height={160}
  //               />
  //             </Box>
  //           )}
  //         </>
  //       );
  //     }

  //     return (
  //       <ReunioesFuturas
  //         key={meetings?.data}
  //         reunioes={meetings}
  //         reunioesCanceladas={listagemReunioesCanceladas}
  //         loading={isMainLoading}
  //         checked={checked}
  //       />
  //     );
  //   },
  // );

  return (
    <Container>
      <Header>
        <section
          className="section-meetings"
          style={{
            background: checked ? 'rgba(0, 0, 0, 0.041)' : '#ffffff',
            cursor: checked ? 'not-allowed' : 'pointer',
          }}
        >
          <TabButton
            onClick={() => handleCheck('futuras')}
            variant="text"
            className="btn-meetings-futures"
            active={tabSelected === 'futuras'}
            disabled={checked}
          >
            FUTURAS
          </TabButton>
          <TabButton
            active={tabSelected === 'passadas'}
            className="btn-meetings-previous"
            onClick={() => handleCheck('passadas')}
            disabled={checked}
          >
            PASSADAS
          </TabButton>
        </section>
        <Box
          className="section-meetings"
          sx={{
            height: '48px',
            alignItems: 'center',
            padding: '10px',
          }}
        >
          <Checkbox
            checked={checked}
            onChange={handleChangeCheckbox}
            color="primary"
          />
          <Text>Ver canceladas</Text>
        </Box>
        <TextField
          fullWidth
          placeholder="Pesquisar pela reunião"
          variant="standard"
          onChange={ev => setSearchForMeetings(ev.target.value)}
          sx={{
            background: '#FFFFFF',
            borderRadius: '4px',
            padding: '9px 12px',
          }}
          InputProps={{
            endAdornment: <SearchRounded />,
            disableUnderline: true, //
          }}
        />
        <React.Fragment key="right">
          {hasBoardsAdmin() === true ? (
            <Tooltip title="Você não pertence a um board como administrador">
              <Box padding="0" margin="0">
                <Button
                  onClick={() => setOpenDrawerCreateMeeting(true)}
                  variant="contained"
                  disabled={hasBoardsAdmin()}
                  sx={{ minWidth: '150px', width: '150px' }}
                >
                  Criar reunião
                </Button>
              </Box>
            </Tooltip>
          ) : (
            <Button
              onClick={() => setOpenDrawerCreateMeeting(true)}
              variant="contained"
              sx={{ minWidth: '150px' }}
            >
              Criar reunião
            </Button>
          )}
        </React.Fragment>
        <SwipeableDrawer
          anchor="right"
          onOpen={() => setOpenDrawerCreateMeeting(true)}
          open={openDrawerCreateMeeting}
          onClose={() => setOpenDrawerCreateMeeting(false)}
        >
          {drawerCriarReuniao()}
        </SwipeableDrawer>
      </Header>

      <PageMeetings sx={{ padding: '0' }}>
        {tabSelected === 'futuras' &&
          (isLoading ? (
            <Box
              alignSelf="center"
              justifyContent="center"
              display="center"
              width="100%"
              paddingTop="200px"
            >
              <CircularProgress />
            </Box>
          ) : (
            <ReunioesFuturas
              key={listOfFutureMeetings}
              reunioes={listOfFutureMeetings}
              reunioesCanceladas={listagemReunioesCanceladas}
              loading={isLoading || loading}
              checked={checked}
            />
          ))}
        {tabSelected === 'passadas' && (
          <ReunioesPassadas
            reunioes={listagemReunioesPassadas}
            loading={loading}
            checked={checked}
          />
        )}
      </PageMeetings>
    </Container>
  );
}
